module.exports = __webpack_public_path__ + "static/GPlogo-70e3e09b58cccbee7c1ea3b9379cce93.png";